import { initialStateData } from 'shared/state';

import { ThemesSchema } from './Themes.schema';

export const state: ThemesSchema = {
  themes: initialStateData,
};
